// extracted by mini-css-extract-plugin
export default {"text-slide":"TextSlide_text-slide__9SaaU","text-slide__text":"TextSlide_text-slide__text__DLSvC"};